import { useQuery } from '@tanstack/react-query';
import { get } from '../../../../lib/api';

export const useAllTiles = ({
  page,
  itemsPerPage,
  sortBy,
  sortDirection,
  tileStatus,
  showAll,
  campaignId,
}) => {
  const params = {
    page,
    limit: itemsPerPage,
    sort_by: sortBy,
    sort_direction: sortDirection,
    tile_status: tileStatus,
    show_all: showAll,
    campaign_id: campaignId,
  };
  const { data = { data: [] }, isLoading } = useQuery(
    ['allTiles', params],
    () => get('/api/client_admin/reports/all_tiles', params),
  );

  return { isLoading, data };
};
